import { ToolProvider } from '@/backend/types'
import { defaultToolConfig, geminiOutputTypes } from '@/modules/Project/Tools/tool-config-presets'
import type { ToolRegistryItem } from '@/modules/Project/Tools/tool-types'

export const gemini25ProTool: ToolRegistryItem = {
  ...defaultToolConfig,
  label: 'Gemini 2.5 Pro',
  description: 'Gemini 2.5 Pro is the latest and most powerful thinking model from Google.',
  outputTypes: geminiOutputTypes,
  provider: ToolProvider.google_genai,
  addedAt: new Date('2025-04-23'),
  icon: 'company-google',
}
